import { render, staticRenderFns } from "./InputTaxRegNo.vue?vue&type=template&id=2928e779&"
import script from "./InputTaxRegNo.vue?vue&type=script&lang=ts&"
export * from "./InputTaxRegNo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2928e779')) {
      api.createRecord('2928e779', component.options)
    } else {
      api.reload('2928e779', component.options)
    }
    module.hot.accept("./InputTaxRegNo.vue?vue&type=template&id=2928e779&", function () {
      api.rerender('2928e779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InputTaxRegNo/InputTaxRegNo.vue"
export default component.exports